/**
 * Google Map API Loader Singleton
 */
const loadStatusMap = new WeakMap<GMXGoogleMapApiLoaderSingleton, string>()

class GMXGoogleMapApiLoaderSingleton {
	get loadStatus(): string {
		return loadStatusMap.get(this) || ''
	}

	set loadStatus(val: string) {
		loadStatusMap.set(this, val)
	}

	constructor() {
		if (!window.gmxGoogleMapApiLoaderSingleton) {
			window.gmxGoogleMapApiLoaderSingleton = this
			loadStatusMap.set(this, '')

			// Because this can be loaded asynchronously, we want to dispatch an event when the singleton is ready so that components can listen for it and then check the load status to determine if they need to initiate a load of the Google Map API
			window.dispatchEvent(new CustomEvent('gmxGoogleMapApiLoaderSingletonReady'))
		} else {
			window.console.log('Tried to instantiate Google Map API Loader singleton...already instantiated')
		}
	}

	public loadMapApiFromAPIKey(mapApiKey: string, region: string, language: string): void {
		if (this.loadStatus === 'loaded') {
			this.mapApiLoadedCallback()
		} else if (this.loadStatus !== 'loading') {
			const newScriptEl = document.createElement('script') as HTMLScriptElement
			newScriptEl.type = 'text/javascript'
			newScriptEl.src = `https://maps.googleapis.com/maps/api/js?v=weekly&key=${encodeURIComponent(mapApiKey)}&language=${encodeURIComponent(language)}&region=${encodeURIComponent(region)}&libraries=places,marker,core&loading=async&callback=window.gmxGoogleMapApiLoaderSingleton.mapApiLoadedCallback`
			newScriptEl.async = true
			newScriptEl.defer = true
			this.loadStatus = 'loading'
			document.body.appendChild(newScriptEl)
		}
	}

	public loadMapApi(clientId: string, region: string, language: string): void {
		if (this.loadStatus === 'loaded') {
			this.mapApiLoadedCallback()
		} else if (this.loadStatus !== 'loading') {
			const newScriptEl = document.createElement('script') as HTMLScriptElement
			newScriptEl.type = 'text/javascript'
			newScriptEl.src = `https://maps.googleapis.com/maps/api/js?v=weekly&client=${encodeURIComponent(clientId)}&language=${encodeURIComponent(language)}&region=${encodeURIComponent(region)}&libraries=places,marker,core&loading=async&callback=window.gmxGoogleMapApiLoaderSingleton.mapApiLoadedCallback`
			newScriptEl.async = true
			newScriptEl.defer = true
			this.loadStatus = 'loading'
			document.body.appendChild(newScriptEl)
		}
	}

	public mapApiLoadedCallback(): void {
		window.dispatchEvent(new CustomEvent('gmxGoogleMapApiLoaded'))
		this.loadStatus = 'loaded'
	}
}

const googleMapapiLoaderSingleton = Object.freeze(new GMXGoogleMapApiLoaderSingleton())
export default googleMapapiLoaderSingleton
